if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');
      this.actionClickHandler = this.handleActionClick.bind(this);
      this.addEventListener('click', this.actionClickHandler);

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      this.observer?.disconnect();
      this.removeEventListener('click', this.actionClickHandler);
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindEvents() {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      });

      if (this.productForm) this.observer.observe(this.productForm);
      if (this.productInfo) this.observer.observe(this.productInfo);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    handleActionClick(evt) {
      const link = evt.target.closest('[data-sticky-atc-target]');
      if (!link) return;
      const target = document.getElementById(link.hash.slice(1));
      if (!target) return;

      window.requestAnimationFrame(() => {
        const optionControl = target.id === 'variants'
          ? target.nextElementSibling?.querySelector('input, select, button')
          : this.productInfo.querySelector('input:not([type="hidden"]), select, button');
        (optionControl || target).focus({ preventScroll: true });
      });
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
